<template>
  <div>
    <avue-crud
    :option="option"
    :table-loading="tableLoading"
    :data="tableData"
    :page="page"
    v-model="modelForm"
    ref="crud"
    @search-change="searchChange"
    @search-reset="searchReset"
    @current-change="currentChange"
    @size-change="sizeChange"
    @on-load="onLoad"
    @refresh-change="refresh"
    @current-row-change="handleRowClick"
    >
    <!--操作栏目-->
    <template slot-scope="{type,size,row}" slot="menu">
      <!-- 查看流程图按钮 -->
      <!-- <el-tooltip content="查看流程图" placement="bottom" effect="light">
        <el-button circle @click="$refs.crud.rowView(row,row.$index)" :size="size" :type="type" icon="el-icon-view"></el-button>
      </el-tooltip> -->
      <!-- 终止申请 -->
       <el-tooltip v-if="!row.processInstanceEndTime" content="终止申请" placement="bottom" effect="light">
        <el-button circle @click="fillTerminationReason(row)" :size="size" :type="type" icon="el-icon-stopwatch"></el-button>
      </el-tooltip>
      <!-- 删除流程数据 -->
       <el-tooltip v-if="row.type !== 'publicRule'" content="删除流程数据" placement="bottom" effect="light">
        <el-button circle @click="deleteProcessData(row)" :size="size" :type="type" icon="el-icon-delete"></el-button>
      </el-tooltip>
    </template>
    <template slot="summary" slot-scope="{row}">
      <div v-html="row.summary" style="text-align: left;"></div>
   </template>
    </avue-crud>
    <el-dialog
      title="终止申请"
      :visible.sync="terminationProcessInfo.dialogVisible"
      :width="300"
      append-to-body="true"
      >

      <el-form  ref="terminationProcessInfo" :model="terminationProcessInfo" label-suffix=":" label-position="left" label-width="120px"  >
      <el-row>
      <el-col :span="23">
      <el-form-item label="终止申请原因"
      prop="reason"
      :rules="[{ 'required': true, 'message': `请输入终止申请原因`}]"
      >
          <el-input type="textarea" rows="7" v-model="terminationProcessInfo.reason" :placeholder="`请输入终止申请原因`"></el-input>
      </el-form-item>
      </el-col>
    </el-row>
  </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="terminationProcessInfo.dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="terminationProcess">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dateFormat } from '@/framework/util/date'

export default {
  data() {
    return {
      terminationProcessInfo: {
        dialogVisible: false,
        processInstanceId: '',
        reason: ''
      },
      tableLoading: false,
      tableData: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      query: {},
      order: {
        oder: '',
        prop: ''
      },
      modelForm: {},
      option: {
        border: true,
        index: true,
        highlightCurrentRow: true,
        page: false,
        height: '400',
        align: 'center',
        menuAlign: 'center',
        searchMenuSpan: 4,
        addBtn: false,
        delBtn: false,
        viewBtn: false,
        editBtn: false,
        menuType: 'icon',
        menuWidth: 160,
        stripe: true,
        column: [
          {
            label: '关键字',
            prop: 'keywords',
            search: true,
            hide: true,
            showColumn: false
          },
          {
            prop: 'processInstanceId',
            label: '流程实例id',
            hide: true,
            type: 'input'
          },
          {
            prop: 'businessKey',
            label: '业务数据id',
            hide: true,
            type: 'input'
          },
          {
            prop: 'processDefinitionId',
            label: '流程定义id',
            hide: true,
            type: 'input'
          },
          {
            prop: 'processInstanceStartUserId',
            label: '流程申请人id',
            hide: true,
            type: 'input'
          },
          {
            prop: 'processCode',
            label: '流程编码',
            hide: true,
            type: 'input'
          },
          {
            prop: 'summary',
            label: '摘要',
            slot: true,
            minWidth: 180
          },
          {
            prop: 'processInstanceName',
            label: '流程名称',
            type: 'input',
            minWidth: 100
          },
          {
            prop: 'processInstanceStartTime',
            label: '开始时间',
            formatter: (row, value) => dateFormat(new Date(value)),
            type: 'input',
            minWidth: 130
          },
          {
            prop: 'processInstanceEndTime',
            label: '结束时间',
            formatter: (row, value) => value ? dateFormat(new Date(value)) : '',
            type: 'input',
            minWidth: 130
          },
          {
            prop: 'duration',
            label: '耗时(ms)',
            type: 'input',
            minWidth: 80
          },
          {
            prop: 'processInstanceStartUserName',
            label: '申请人',
            type: 'input',
            minWidth: 80
          },
          {
            label: '开始节点',
            prop: 'startActId',
            type: 'input',
            minWidth: 120
          },
          {
            label: '结束节点',
            prop: 'endActId',
            type: 'input',
            minWidth: 120
          },
          {
            label: '删除原因',
            prop: 'deleteReason',
            type: 'input',
            minWidth: 120
          }
        ]
      }
    }
  },

  components: {},

  methods: {
    fillTerminationReason(row) {
      this.terminationProcessInfo = {
        dialogVisible: true,
        processInstanceId: row.processInstanceId,
        reason: ''
      }
    },
    terminationProcess() {
      // handleButtonConfirm() {
      this.$refs.terminationProcessInfo.validate((valid) => {
        if (valid) {
          // deleteReason
          // /flow-task-change/delete-process-instance
          // processInstanceId
          this.$http.delete('/flow-task-change/delete-process-instance', { params: {
            deleteReason: this.terminationProcessInfo.reason,
            processInstanceId: this.terminationProcessInfo.processInstanceId
          }}).then((res) => {
            if (res.code === 200) {
              this.terminationProcessInfo.dialogVisible = false
              this.onLoad()
            }
          }).catch((error) => {
            this.$alert(error.msg, '错误', {
              confirmButtonText: '确定',
              type: 'error'
            })
          })
        }
      })
    },
    onLoad(page = this.page, params = this.query, order = this.order) {
      this.tableLoading = true
      this.$http.get('/flow-monitor/process-instance-query', { params: {
        pageNum: page.currentPage,
        pageSize: page.pageSize,
        keywords: params.keywords
      }}).then(
        response => {
          this.tableLoading = false
          this.tableData = response.data.records
          this.page.total = response.data.total || response.data.records.length
        }
      ).catch(
        error => {
          this.tableLoading = false
          this.$message.error(error.msg || error.message)
        }
      )
    },
    // 搜索改变事件
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') delete params[key]
      }
      done()
      this.page.currentPage = 1
      this.query = params
      this.onLoad()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.page.currentPage = 1
      this.onLoad()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refresh: function() {
      this.onLoad()
    },
    handleRowClick: function(row) {
      this.chooseRowId = row.id
      this.$emit('rowClick', row)
    },
    deleteProcessData(row) {
      this.$confirm('此操作将永久删除该流程数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // /flow-monitor/delete-process-data/{processInstanceId}
        this.$http.delete('/flow-monitor/delete-process-data/' + row.processInstanceId).then((res) => {
          if (res.code === 200) {
            this.onLoad()
          }
        }).catch((error) => {
          this.$alert(error, '错误', {
            confirmButtonText: '确定',
            type: 'error'
          })
        })
      }).catch(() => {
      })
    }

  }
}

</script>
<style lang='scss' scoped>

</style>
